import { useState, useEffect } from "react";
let interval: NodeJS.Timeout;
export const useInViewport = (id: string) => {
  const [isInViewport, setIsInViewport] = useState<boolean>(true);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInViewport(entry.isIntersecting);
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0,
      }
    );

    let element: HTMLElement | null = null;
    interval = setInterval(() => {
      if (id) {
        element = document.getElementById(id);
        if (element) {
          clearInterval(interval);
          observer.observe(element);
        }
      }
    }, 1000);

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, [id]);

  return isInViewport;
};
